import { useStores } from "#stores";
import { useBreadcrumb } from "#structure/providers/breadcrumb";
import { contextLevelFromUrl } from "#resources/helpers/url/url";
import type { AmplitudeBaseContext } from "#structure/providers/analytics/event-types";

export function useAmplitudeBaseContext(): AmplitudeBaseContext {
	const { authStore, organizationStore, placeStore, eventStore } = useStores();
	const { currentPage } = useBreadcrumb();
	const rawLevel = contextLevelFromUrl();
	const level = rawLevel === "organization" ? "org" : rawLevel;

	return {
		pageName: currentPage ?? "",
		placeName: placeStore.place?.name ?? "",
		orgName: organizationStore.organization?.name ?? "",
		eventName: eventStore.event?.name ?? "",
		placeId: placeStore.place?.id ?? "",
		eventId: eventStore.event?.id ?? "",
		userId: authStore.currentEmployee?.id ?? "",
		organizationId: organizationStore.organization?.id ?? "",
		level,
	};
}
